import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  formattedCurrencyAmount: 0,
  rateDivided: 0
});



// WEBPACK FOOTER //
// ./src/store/stepsStore.js